
import Header from './components/Header';
import ArticleHeader from './components/ArticleHeader';
import ArticleBody from './components/ArticleBody';
import ArticleFooter from './components/ArticleFooter';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import FixedMenu from './components/FixedMenu';
import { SEO } from '../../utils/seo';
import { useState, useEffect, useCallback } from 'react';

export default function HomePage() {
  const [showFixedMenu, setShowFixedMenu] = useState(false);

  const handleScroll = useCallback(() => {
    setShowFixedMenu(window.scrollY > 800);
  }, []);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [handleScroll]);

  return (
    <>
      <SEO
        title="コインランドリー経営.com｜開業・初期費用・運営・防犯を解説"
        description="コインランドリー経営は、無人経営が基本のため人件費が抑えられ、安定した収益が期待できるビジネスモデルです。コインランドリー経営のコツを中心に、開業手順や初期費用、売上、防犯面などの不安も解消する総合ガイドです。"
        keywords="コインランドリー 経営, コインランドリー 開業, コインランドリー 初期費用, コインランドリー 売上"
        ogImage="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/5647be9c62421fc18e806d9460b60cd9.jpeg"
        author="Laundrysite編集部"
        publishedTime="2024-01-15T09:00:00+09:00"
        modifiedTime="2025-06-01T09:00:00+09:00"
      />
      <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
        <Header />
        <ArticleHeader />
        <ArticleBody />
        <CTASection />
        <ArticleFooter />
        <Footer />
        {showFixedMenu && <FixedMenu />}
      </div>
    </>
  );
}